// extracted by mini-css-extract-plugin
export default {"container":"CreateSocietyModal_container__WQENU","main":"CreateSocietyModal_main__rtZpW","wrapper":"CreateSocietyModal_wrapper__p2GsN"};